<template>
    <div class="toolbar">
        <div class="mask" v-show="mask_visible"></div>
        <div class='back'>
            <el-tooltip class="item" effect="dark" content="返回" placement="top-start">
                <el-button class="back_btn" type="text" icon="icon-top_back" @click="handleBack"></el-button>
            </el-tooltip>    
        </div>
        <div class="toorbar_left">
            <div class="item1" v-for="item, index in toorbar_list" v-if="item[1] == '1' || item[1] == '2' || item[1] == '5' || item[1] == '6'">
                <span v-if="item[1] == '2'" style="font-size: 14px; margin-right: 5px;">{{item[3]}}</span>
                <input class="el-input__inner" style="background:#636363;color:#e2e2e2;border:1px solid #323232;" size="mini" min="0" max="360" step="1" type="number" v-if="item[1] == '2'"  v-model="item[4]" @input="handleInput(item, index)"></input>
                <el-tooltip class="item" effect="dark"  placement="top-start">
                    <button type="button" :class="'icon-' + item[2]" v-if="item[1] == '1'"  @mousedown.prevent="handleToorbarLeftDown($event,item)"  @mouseup="handleToorbarLeftUp(item)" @mouseout="handleToorbarLeftLeave(item, $event)"></button>
                    <button v-if="item[1] == '5'" :class="item[4] != undefined ? 'icon-' + item[2] + ' active' : 'icon-' + item[2]" @mousedown="handleOutDown(item)"  @mouseup="handleOutUp(item)"></button>
                    <div slot="content">{{item[5]}}</div> 
                </el-tooltip>
                <!-- <i :class="'icon-' + item[2]" v-if="item[1] == '1'" style="background:green" @mousedown.prevent="handleToorbarLeftDown($event,item)"  @mouseup="handleToorbarLeftUp(item)" @mouseout="handleToorbarLeftLeave(item, $event)"></i> -->
                <!-- <i v-if="item[1] == '5'" :class="item[4] != undefined ? 'icon-' + item[2] + ' active' : 'icon-' + item[2]" style="background:white" @mousedown="handleOutDown(item)"  @mouseup="handleOutUp(item)"></i> -->
                <el-checkbox v-if="item[1] == '6' && checkboxValue(item)" style="padding-top: 7px;" v-model="checkbox_true" @change="handleToolebarCheckbox(item)">{{item[3]}}</el-checkbox>
                <el-checkbox v-if="item[1] == '6' && !checkboxValue(item)" style="padding-top: 7px;" v-model="checkbox_false"  @change="handleToolebarCheckbox(item)">{{item[3]}}</el-checkbox>
                
            </div>
            
        </div>
        <div class="toorbar_right">
            <div class="item1" v-for="item, index in toorbar_list_left" v-if="item[1] == '1' || item[1] == '3' || item[1] == '5'">
                <div class="item1 title" style="background:#636363;color:#e2e2e2;border:1px solid #323232;" v-if="item[1] == '3'" v-show="title_change_status">{{item[3].length > 6 ? item[3].substring(0,6) + '...':item[3]}}<i class="icon-home_edit" @click="hasndleChangeNameStatus()"></i></div>
                <div class="input_title" v-if="item[1] == '3'" v-show="!title_change_status"><input id="name" v-model="item[3]" @blur="handleName(item)" @keyup.enter="handleName(item)" ref="input_title"><i class="icon-home_edit"></i></div>
                <!-- <i v-if="item[1] == '1'" :class="'icon-' + item[2]" @mousedown="handleOutDown(item)"  @mouseup="handleOutUp(item)"></i>
                <i v-if="item[1] == '5'" :class="item[4] != undefined ? 'icon-' + item[2] + ' active' : 'icon-' + item[2]" @mousedown="handleOutDown(item)"  @mouseup="handleOutUp(item)"></i> -->
                <el-tooltip class="item" effect="dark"  placement="top-start">
                    <button v-if="item[1] == '1'" :class="'icon-' + item[2]" @mousedown="handleOutDown(item)"  @mouseup="handleOutUp(item)"></button>
                    <button v-if="item[1] == '5'" :class="item[4] != undefined ? 'icon-' + item[2] + ' active' : 'icon-' + item[2]" @mousedown="handleOutDown(item)"  @mouseup="handleOutUp(item)"></button>
                    <div slot="content">{{item[5]}}</div> 
                </el-tooltip>
            </div>
        </div>
        <div class="toorbar_right_right">
            <div class="item1" v-for="item, index in toorbar_list_right" v-if="item[1] == '1' || item[1] == '3'">
                <el-tooltip class="item" effect="dark"  placement="top-start">
                    <button class="item-button" v-if="item[0] != 'save' && item[0] != 'unsave' && item[0] != 'saveToServer' && item[0] != 'export' && item[1] == '1'" :class="'icon-' + item[2]" @mousedown="handleOutDown(item)"  @mouseup="handleOutUp(item)"></button>
                    <div slot="content">{{item[5]}}</div> 
                </el-tooltip>
                <!-- <i v-if="item[0] != 'save' && item[0] != 'unsave' && item[0] != 'saveToServer' && item[0] != 'export' && item[1] == '1'" :class="'icon-' + item[2]" @mousedown="handleOutDown(item)"  @mouseup="handleOutUp(item)"></i> -->
                <el-button class="save" type="warning" size="small" v-if="(item[0] == 'save' || item[0] == 'unsave')&& item[1] == '1'" :disabled="disabled" v-show="disabled" >保存</el-button>
                <el-button class="unsave" type="warning" size="small" v-if="(item[0] == 'save' || item[0] == 'unsave')&& item[1] == '1'"  :loading="save_loading" v-show="!disabled" @click="handleSave(item)">保存</el-button>
                <el-button id="export" type="warning" size="small" v-if="item[0] == 'saveToServer'" @click="handleOutUp(item)">{{item[3]}}</el-button>
                <el-button id="export" type="warning" size="small" v-if="item[0] == 'export'" @click="handleOutUp(item)">导出</el-button>
            </div>
        </div>
        <psocket :attributes="attributes" v-if="platform == 'qt'"/>
    </div>
</template>
<script>
    // Psocket 组件
    import Psocket from '@/components/Flash/PSocket'
    import EUY from '@/common/scripts/euy.js'
    // 通讯协议
    import Protocol from '@/common/scripts/protocol.js'
    export default {
        data () {
            return {
                platform: this.$route.query.platform,
                mask_visible: false,
                flashvars: {
                    module: 'TOOLBAR_NAME'
                },
                attributes: {
                    id: 'TOOLBAR-PSOCKET',
                    class: 'psocket',
                },
                init: true,
                out_time: null,
                out_time1: null,
                in_time: null,
                in_time1: null,
                senderId: '',
                toorbar_list: [],
                left_time1: null,
                left_time2: null,
                title_name: '',
                title_name_total: '',
                title_change_status: true,
                toorbar_list_left: [],
                toorbar_list_right: [],
                checkbox_true: true,
                checkbox_false: false,
                disabled:true,
                save_loading:false,
            }
        },
        computed: {

        },
        components: {
            Psocket
        },
        methods: {
            handleBack() {
                let toolbar_1_30 = {
                    packageId: 0,
                    senderId: TOOLBAR,
                    senderName: TOOLBAR_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: 30,
                    protoBytesType: null,
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(this.platform, toolbar_1_30)
            },

            checkboxValue(item)
            {
                console.log(item.length > 4 ? true : false);
                return item.length > 4 ? true : false;
            },

            // 改名字按钮
            hasndleChangeNameStatus ()
            {
                this.title_change_status = false
                setTimeout(()=>{
                    this.$refs.input_title[0].select();
                },200);
            },

            // 改名字
            handleName (item)
            {
                this.title_change_status = true
                if(1 > item[3].length){
                    item[3] = '未命名';
                }
                let value = ''
                this.handleSendMsg (item[0], value ,item[3])
            },

            // 缩小按下
            handleOutDown (item)
            {
                this.out_time = setTimeout(() => {
                    this.out_time1 = setInterval(() => {
                        let value = ''
                        let text = ''
                        this.handleSendMsg(item[0], value, text)
                    },20)
                },500)
            },

            // 缩小抬起
            handleOutUp (item)
            {
                clearInterval(this.out_time)
                clearInterval(this.out_time1)
                // this.handleOut(item)
                let value = ''
                let text = item[3]
                this.handleSendMsg(item[0], value, text)

            },
            // 保存按钮的点击
            handleSave (item)
            {
                this.save_loading = true
                let value = ''
                let text = ''
                this.handleSendMsg(item[0], value, text)
            },

            // 放大按下
            handleInDown ()
            {
                this.in_time = setTimeout(() => {
                    this.in_time1 = setInterval(() => {
                        this.handleIn()
                    },20)
                },500)
            },

            // 放大抬起
            handleInUp ()
            {
                clearInterval(this.in_time)
                clearInterval(this.in_time1)
                this.handleIn()
            },

            handleToorbarLeftDown (event,item)
            {
                this.left_time1 = setTimeout(() => {
                    this.left_time2 = setInterval(() => {
                        let value = ''
                        let text = ''
                        this.handleSendMsg(item[0], value, text)
                    },30)
                },500)
                //console.log("handleToorbarLeftDown====================")
            },

            handleToorbarLeftUp (item)
            {
                clearInterval(this.left_time2)
                clearInterval(this.left_time1)
                let value = ''
                let text = ''
                this.handleSendMsg(item[0], value, text)
            },

            handleToolebarCheckbox(item)
            {
                this.handleSendMsg(item[0], '', '');
            },

            handleToorbarLeftLeave(item, $event)
            {
                if('null'!= this.left_time2){
                    clearInterval(this.left_time2)
                }
                if('null'!= this.left_time1){
                    clearInterval(this.left_time1)
                }
                let value = ''
                let text = ''
                // this.handleSendMsg(item[0], value, text)
            },

            handleInput (item, index)
            {
                if(item[4] <0){
                    this.toorbar_list[index][4] = 0
                }else if(item[4] > 360){
                    this.toorbar_list[index][4] = 360
                }else{
                    this.toorbar_list[index][4] = item[4]
                }
                let text = ''
                this.handleSendMsg(item[0], item[4], text)
            },

            // 发送消息
            handleSendMsg (id, value, text)
            {
                let  platform = this.$route.query.platform
                let _this = this
                let MToolBarChangeData  = new proto.com.proto.toolbar.MToolBarChangeData()
                MToolBarChangeData.setId(id)
                MToolBarChangeData.setValue(value)
                MToolBarChangeData.setText(text)
                // protobuf 序列化
                let protoBytes = MToolBarChangeData.serializeBinary()
                // Uint8Array 转换 Array
                let protoBytesArray = Array.from(protoBytes)
                let toolbar_5_7 = {
                    packageId: 0,
                    senderId: TOOLBAR,
                    senderName: TOOLBAR_NAME,
                    receiverId: _this.senderId,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 5,
                    messageId: 7,
                    protoBytesType: 'proto.com.proto.toolbar.MToolBarChangeData',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, toolbar_5_7)
            },
        },

        mounted ()
        {
            let _this = this
            let  platform = this.$route.query.platform
            // ACTION
            // 模块初始化
            Protocol.onSocketInit(platform, TOOLBAR_NAME, TOOLBAR)
            // 模块与服务器建立链接
            Protocol.onSocketConnect(platform, TOOLBAR_NAME)
            // 模块与服务器建立链接
            Protocol.onSocketRegister(platform, TOOLBAR_NAME, TOOLBAR)
            window[TOOLBAR_NAME].domReady = () => {
            }

            window[TOOLBAR_NAME].message = (senderId, packageId, sessionId, messageId, protoBytes) => {
                // 显示工具栏
                if(sessionId == 5 && messageId == 6) {
                    _this.senderId = senderId
                    let opeList = Protocol.deserializeBinary('proto.com.proto.toolbar.MToolList', protoBytes).array
                    for(let i=0;i<opeList[1].length;i++){
                        if(opeList[1][i][1] == '2'){
                            if(!opeList[1][i][4]){
                                opeList[1][i][4] = 0
                            }
                        }
                    }
                    let opeList2 = []
                    for(var i=0;i<opeList[1].length;i++){
                        if(opeList[1][i][4] == -1){
                            opeList[1][i-1][2] = opeList[1][i-1][2] + ' left'
                            opeList[1][i+1][2] = opeList[1][i+1][2] + ' right'
                        }
                        opeList2.push(opeList[1][i])
                    }
                    let opeList3 = []
                    for(var i=opeList2.length-1;i>=0;i--){
                        opeList3.push(opeList2[i])
                    }
                    _this.checkbox_true = true;
                    _this.checkbox_false = false;
                    _this.toorbar_list = opeList3
                    console.log('toorbar_list', JSON.stringify(opeList3))
                }else if(sessionId == 5 && messageId == 8){ //显示左侧工具栏
                    _this.senderId = senderId
                    let opeList = Protocol.deserializeBinary('proto.com.proto.toolbar.MToolList', protoBytes).array
                    let opeList2 = []
                    console.log('58', opeList)
                    for(var i=0;i<opeList[1].length;i++){
                        if(opeList[1][i][4] == -1){
                            opeList[1][i-1][2] = opeList[1][i-1][2] + ' left'
                            opeList[1][i+1][2] = opeList[1][i+1][2] + ' right'
                        }
                        if(opeList[1][i][1] == 3){
                            if(!opeList[1][i][3]){
                                opeList[1][i][3] = '未命名'
                            }
                        }
                        opeList2.push(opeList[1][i])
                    }
                    _this.toorbar_list_left = opeList2
                    console.log('toorbar_list_left', opeList2)
                }else if(sessionId == 5 && messageId == 9) { //显示右侧工具栏
                    _this.senderId = senderId
                    let opeList = Protocol.deserializeBinary('proto.com.proto.toolbar.MToolList', protoBytes).array
                    let opeList2 = []
                    for(var i=0;i<opeList[1].length;i++){
                        if(opeList[1][i][4] == -1){
                            opeList[1][i-1][2] = opeList[1][i-1][2] + ' left'
                            opeList[1][i+1][2] = opeList[1][i+1][2] + ' right'
                        }
                        if(opeList[1][i][1] == 3){
                            if(!opeList[1][i][3]){
                                opeList[1][i][3] = '未命名'
                            }
                        }
                        opeList2.push(opeList[1][i])
                    }

                    // 判断保存按钮的状态
                    for (var i=0;i<opeList2.length;i++){
                        // console.log("保存按钮的状态 " + opeList2[0][0])
                        if (opeList2[0][0] == 'save'){
                            _this.disabled = false
                        }else if (opeList2[0][0] == 'unsave'){
                            _this.disabled = true
                            _this.save_loading = false
                        }
                    }
                    _this.toorbar_list_right = opeList2
                    console.log('toorbar_list_right', opeList2)
                }else if (sessionId == 1 && messageId == 13){ // 锁定模块
                    _this.mask_visible = true
                }else if (sessionId == 1 && messageId == 14){ // 解除锁定
                    _this.mask_visible = false
                }else if(sessionId == 1 && messageId == 12){ // changeTab
                    _this.toorbar_list = []
                    _this.toorbar_list_left = []
                    _this.toorbar_list_right = []
                }
            }
        },
    }
</script>

<style lang="stylus" scoped>
    .toolbar {
        position: relative
        height: 36px
        background: #434343//#f0f0f0
        overflow: hidden
        .mask {
            position: absolute
            top: 0
            right: 0
            bottom: 0
            left: 0
            background: rgba(0, 0, 0,.5)
            z-index: 1
        }
        .back {
            position: absolute
            top: 1px
            .back_btn {
                padding-top: 0px
                cursor: pointer
                font-size: 30px
                height:30px
                width:30px
                margin-left:10px
                margin-top:3px
                color:#e2e2e2
                // background:#323232//#f0f0f0
                &:hover {
                    background:#5c5c5c//#e1e1e1
                }
                &:active {
                    background:#232323//#cccccc
                }
            }
        }
        .toorbar_right_right {
            position: absolute
            top: 3px
            right: 0
            .item1 {
                float left
                margin-right 16px
                i {
                    height: 30px
                    line-height: 30px
                    cursor: pointer
                    font-size 28px
                    color #545454
                    border 1px solid #ccc
                    border-radius 4px
                }
                .item-button {
                    height: 30px
                    line-height: 30px
                    cursor: pointer
                    font-size: 28px
                    color: #d1d1d1//#545454
                    border: 1px solid #636363//#ccc
                    border-radius: 4px
                    background:#434343//:#f0f0f0
                    &:hover {
                        background:#5c5c5c//#e1e1e1
                    }
                    &:active {
                        background:#232323//#cccccc
                    }
                }
                .active {
                    background ccc
                    &:hover {
                        background e1e1e1
                    }
                    &:active {
                        background ccc
                    }
                }
                .right {
                    margin-left -16px
                    border-radius: 0px 4px 4px 0px
                }
                .left {
                    border-radius: 4px 0px 0px 4px
                }
                #export {
                    padding: 8px 15px
                    background ccc
                }
                .save {
                    width :80px
                    height:30px
                    background: #f0f0f0
                    color: white
                    padding: 8px 15px

                }
                .unsave {
                    width :80px
                    height:30px
                    color: white
                    background: #ff4f53
                    padding: 8px 15px
                    border: 0px
                    &:hover  {
                        background #ff6e71
                    }
                    &:active {
                        background #e50b26
                    }
                }
            }
        }
        .toorbar_left {
            overflow hidden
            width 600px
            margin 0 auto
            margin-top 3px
            .item1 {
                float right
                margin-left 16px
                input {
                    width 80px
                    height 30px
                }
                span{
                    color:#e2e2e2
                }
                // i {
                //     height: 30px
                //     line-height: 30px
                //     cursor: pointer
                //     font-size: 28px
                //     color: #545454
                //     border: 1px solid #ccc
                //     border-radius: 4px
                // }
                button {
                    height: 30px
                    line-height: 30px
                    cursor: pointer
                    font-size: 28px
                    color:#d1d1d1//#545454
                    border: 1px solid #636363//#ccc
                    border-radius: 4px
                    background:#434343//#f0f0f0
                    &:hover {
                        background:#5c5c5c//#e1e1e1
                    }
                    &:active {
                        background:#232323//#cccccc
                    }
                }
                .active {
                    background #232323//#ccc
                    &:hover {
                        background #5c5c5c//#e1e1e1
                    }
                    &:active {
                        background #232323
                    }
                }
                .right {
                    margin-left -16.5px
                    border-radius: 0px 4px 4px 0px
                }
                .left {
                    border-radius: 4px 0px 0px 4px
                }
            }
        }
        .position {
            margin-left -6px
        }
        .toorbar_right {
            position: absolute
            height: 36px
            left 60px
            top 3px
            .item1 {
                float left
                margin-right 16px
                i {
                    height: 30px
                    line-height: 30px
                    cursor: pointer
                    font-size 28px
                    color #545454
                    border 1px solid #ccc
                    border-radius 4px
                }
                button {
                    height: 30px
                    line-height: 30px
                    cursor: pointer
                    font-size: 28px
                    color: #d1d1d1//#545454
                    border: 1px solid #636363//#ccc
                    border-radius: 4px
                    background:#434343//#f0f0f0
                    &:hover {
                        background:#5c5c5c//#e1e1e1
                    }
                    &:active {
                        background:#232323//#cccccc
                    }
                }
                .active {
                    background #232323//#ccc
                    &:hover {
                        background #5c5c5c//green//#e1e1e1
                    }
                    &:active {
                        background #323232//#ccc
                    }
                }
                .right {
                    margin-left -16px
                    border-radius: 0px 4px 4px 0px
                }
                .left {
                    border-radius: 4px 0px 0px 4px
                }
            }
            .title {
                border 1px solid #d3d3d3
                height: 22px
                line-height: 22px
                border-radius 3px
                margin-top 3px
                padding 0 5px
                background #dbdbdb
                margin-right 14px
                width 113px
                .icon-home_edit {
                    font-size 28px
                    float right
                    color #9d9d9d
                    height 22px
                    line-height 22px
                    border none
                    background none
                    &:hover {
                        background none
                    }
                    &:active {
                        background none
                    }
                }
            }
            .input_title {
                border 1px solid #d3d3d3
                height: 22px
                line-height: 22px
                border-radius 3px
                margin-top 3px
                padding 0 5px
                background #fff
                margin-right 14px
                width 113px
                float left
                .icon-home_edit {
                    font-size 28px
                    float right
                    color #9d9d9d
                    height 22px
                    line-height 22px
                    border none
                    background none
                    &:hover {
                        background none
                    }
                    &:active {
                        background none
                    }
                }
                input {
                    width 80px
                    font-size 12px
                    padding 2px 3px
                    outline none
                    border none
                    box-sizing border-box
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Toolbar.vue?3eb96b6a